/* eslint-disable no-unused-vars */
//  Internals
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Popover, Checkbox } from "antd";
import {
	DateRangePicker,
	Checkbox as RSuiteCheckbox,
	CheckboxGroup as RSuiteCheckboxGroup,
} from "rsuite";
import "rsuite/dist/rsuite.min.css";
import { FiFilter } from "react-icons/fi";
import SearchUserBox from "./SearchUserBox";
import { forEach, isArray, isEmpty } from "lodash";
import { useStore } from "../../zustand/store";
const CheckboxGroup = Checkbox.Group;

//  Component starts
const TableHeader = ({
	columns,
	columnKey,
	sortCol,
	filterValue,
	filterDate,
	tabChangeCounter,
	payload,
}) => {
	const { searchedUsers, setSearchedUsers } = useStore((state) => state);
	const [plainOptions, setPlainOptions] = useState([]);
	const [filteredOptions, setFilteredOptions] = useState([]);
	const [indeterminate, setIndeterminate] = useState(false);
	const [checkAll, setCheckAll] = useState(true);
	const [checkedList, setCheckedList] = useState([]);
	const [selectedColumn, setSelectedColumn] = useState();
	const [selectedColumnForSort, setSelectedColumnSort] = useState();
	const [orderBy, setOrderBy] = useState();

	const [usersOptions, setUsersOptions] = useState([]);
	const [selected, setSelected] = useState([]);
	const [prevList, setPrevList] = useState([]);
	const [prevSelected, setPrevSelected] = useState([]);

	const [filterArray, setFilterArray] = useState([]);

	useEffect(() => {
		if (filteredOptions?.[selectedColumn?.aliasFilter]?.length) {
			setCheckAll(false);
		}
	}, [selectedColumn]);

	useEffect(() => {
		setPlainOptions(columns.filterOptions);
		resetAllFilters();
	}, [columns.filterOptions]);

	useEffect(() => {
		if (tabChangeCounter && tabChangeCounter >= 1) {
			setFilteredOptions();
			setIndeterminate(false);
			setCheckAll(true);
			setCheckedList([]);
			setPlainOptions([]);
		}
	}, [tabChangeCounter]);

	useEffect(() => {
		if (payload?.filter) {
			let filterObj = payload.filter;
			let _keys = Object.keys(filterObj);
			_keys.forEach((_key) => {
				let _filterOptions = filterObj?.[_key];
				if (
					_filterOptions?.length === plainOptions?.length ||
					_filterOptions?.length === 0
				) {
					setFilteredOptions((values) => {
						return { ...values, [_key]: null };
					});
				} else {
					setFilteredOptions((values) => {
						return { ...values, [_key]: _filterOptions };
					});
				}
			});
		}
	}, []);

	useEffect(() => {
		if (payload?.filter_date) {
			let filterObj = payload.filter_date;
			let _keys = Object.keys(filterObj);
			_keys.forEach((_key) => {
				let _dates = filterObj?.[_key]?.split?.(",");
				let _filterOptions = _dates
					? [new Date(_dates?.[0]), new Date(_dates?.[1])]
					: null;
				setFilteredOptions((values) => {
					return { ...values, [_key]: _filterOptions };
				});
			});
		}
	}, []);

	useEffect(() => {
		if (payload?.sort) {
			let sortObj = payload.sort;
			let _keys = Object.keys(sortObj);
			let _column = columns?.find((column) => column.alias === _keys[0]);
			setSelectedColumnSort(_column);
			if (payload.sort?.[_keys?.[0]] === "ASC") {
				setOrderBy("desc");
			} else {
				setOrderBy("asc");
			}
		}
	}, []);

	/******************************************************************************************
    @Purpose    :   To render the class dynamically
    *******************************************************************************************/
	const renderClass = (column) => {
		let classes = "";
		if (column.sort) classes += "cursor-pointer ";
		if (column.type === "string") classes += "text-left";
		if (column.maxWidth === true) classes += " th-lg";
		if (column.type === "number") classes += "text-right";
		if (["date", "boolean", "checkbox"].includes(column.type))
			classes += "text-left";
		return classes;
	};

	/******************************************************************************************
    @Purpose    :   To handle the sort
    *******************************************************************************************/
	const raiseSort = (column) => {
		if (column.sort) {
			let _orderBy = orderBy;
			if (_orderBy === "asc") {
				setOrderBy("desc");
			} else {
				setOrderBy("asc");
			}
			setSelectedColumnSort(column);
			sortCol &&
				sortCol({
					sort: _orderBy === "asc" ? "ASC" : "DESC",
					alias: column?.alias,
				});
		}
	};

	/******************************************************************************************
    @Purpose    :   To render the sort icon
    *******************************************************************************************/
	const renderSortIcon = (column) => {
		if (column.sort) {
			if (column.path !== selectedColumnForSort?.path)
				return <i className="bx bxs-sort-alt"></i>;
			if (orderBy === "desc")
				return (
					<i className={"bx bxs-chevron-up"} style={{ color: "blue" }}></i>
				);
			return (
				<i className={"bx bxs-chevron-down"} style={{ color: "blue" }}></i>
			);
		}
	};

	const onChange = (list) => {
		setCheckedList(list);
		setIndeterminate(!!list.length && list.length < plainOptions.length);
		setCheckAll(list.length === plainOptions.length);
	};

	const onCheckAllChange = (e) => {
		setCheckedList(e.target.checked ? plainOptions : []);
		setIndeterminate(false);
		setCheckAll(e.target.checked);
	};

	const filterCallHandler = (optionsSelected) => {
		setFilteredOptions({
			...filteredOptions,
			[selectedColumn?.aliasFilter]: optionsSelected,
		});
		// send only
		filterValue &&
			filterValue({
				alias: selectedColumn?.aliasFilter,
				filter: optionsSelected,
			});
	};

	const handleSetFilter = () => {
		resetAllFilters();
		if (checkedList?.length) {
			// send all
			if (checkedList.length == plainOptions.length) {
				filterCallHandler(null);
			} else {
				filterCallHandler(checkedList);
			}
		}
	};

	const getUserIds = (_users) => {
		let _userIds = [];
		_users.forEach((item) => {
			let val = JSON.parse(item);
			_userIds.push(val?.id);
		});
		return _userIds;
	};

	const getUsersLabelArray = (usersOptions) => {
		let _users = [];
		if (isArray(usersOptions)) {
			usersOptions.map((element) => {
				let obj = convertListItemToObject(element);
				_users.push(obj);
			});
		}
		return _users;
	};

	const removeUserFilter = () => {
		setFilteredOptions({
			...filteredOptions,
			[selectedColumn?.aliasFilter]: [],
		});
		setSearchedUsers({ [columnKey]: { [selectedColumn?.aliasFilter]: [] } });

		setPrevList([]);
		setPrevSelected([]);
		setSelected([]);

		filterValue &&
			filterValue({
				alias: selectedColumn?.aliasFilter,
				filter: null,
			});
	};

	const handleSetUserFilter = () => {
		resetAllFilters();
		if (prevSelected?.length) {
			let tempUsers = JSON.parse(JSON.stringify(prevSelected));
			const userSet = new Set(tempUsers);
			tempUsers = Array.from(userSet);
			setPrevSelected(tempUsers);

			let userIds = getUserIds(tempUsers);
			let _users = getUsersLabelArray(tempUsers);
			setPrevList(_users);
			setFilteredOptions({
				...filteredOptions,
				[selectedColumn?.aliasFilter]: prevSelected,
			});
			setSearchedUsers({
				[columnKey]: { [selectedColumn?.aliasFilter]: prevSelected },
			});

			filterValue &&
				filterValue({
					alias: selectedColumn?.aliasFilter,
					filter: userIds,
				});
		} else {
			removeUserFilter();
		}
	};

	const handleSetFilterDate = (date) => {
		if (date?.length) {
			const dates = [];
			dates.push(
				new Date(new Date(date?.[0]).setHours(0, 0, 0)).toISOString(),
				new Date(new Date(date?.[1]).setHours(23, 59, 59)).toISOString()
			);
			setFilteredOptions({
				...filteredOptions,
				[selectedColumn?.alias]: date,
			});
			filterDate &&
				filterDate({
					alias: selectedColumn?.alias,
					filter: dates,
				});
		} else {
			setFilteredOptions({
				...filteredOptions,
				[selectedColumn?.alias]: null,
			});
			filterDate && filterDate();
		}
	};

	const handleCloseFilter = () => {
		setFilterArray({ ...filterArray, [selectedColumn?.aliasFilter]: false });
	};

	const renderFilterOptions = () => {
		return (
			<div className="column">
				<div className="popover-container">
					<Checkbox
						indeterminate={indeterminate}
						onChange={onCheckAllChange}
						checked={checkAll}
					>
						All
					</Checkbox>
					<CheckboxGroup
						className="column"
						options={plainOptions}
						value={checkedList}
						onChange={onChange}
					/>
				</div>
				<div className="right">
					<button
						className="rs-btn rs-btn-medium mr-r5"
						onClick={() => handleCloseFilter()}
					>
						Close
					</button>
					<button
						className="rs-btn rs-btn-primary rs-btn-sm"
						onClick={() => handleSetFilter()}
					>
						Apply
					</button>
				</div>
			</div>
		);
	};

	useEffect(() => {
		if (searchedUsers?.[columnKey]?.[selectedColumn?.aliasFilter]) {
			let filteredUserValues =
				searchedUsers?.[columnKey]?.[selectedColumn?.aliasFilter] || [];
			let _users = getUsersLabelArray(filteredUserValues);
			setPrevList(_users);
			setPrevSelected(filteredUserValues);
		}
	}, [selectedColumn]);

	const updatePrevSelectOnSelectChange = (list) => {
		let usersSet = new Set([...prevSelected, ...list]);
		let selectedArray = Array.from(usersSet);
		const listArray = getUsersLabelArray(selectedArray);
		setPrevList(listArray);
		setPrevSelected(Array.from(selectedArray));
	};

	const findDeleted = (fullList, deletedList) => {
		let deletedVal = null;
		for (let i = 0; i < fullList.length && i < deletedList.length; i++) {
			if (fullList[i] !== deletedList[i]) {
				deletedVal = fullList[i];
				break;
			}
		}
		if (isEmpty(deletedVal)) {
			deletedVal = fullList[fullList.length - 1];
		}
		return deletedVal;
	};

	const deleteFromArray = (array, index) => {
		if (index > -1) {
			// only splice array when item is found
			array.splice(index, 1); // 2nd parameter means remove one item only
		}
		return array;
	};

	const convertListItemToObject = (element) => {
		let temp = JSON.parse(element);
		let name = temp.name;
		return {
			label: name,
			value: JSON.stringify(temp),
		};
	};

	const onChangeUser = (list, event) => {
		if (event.target.checked) {
			setSelected(list);
			updatePrevSelectOnSelectChange(list);
		} else {
			let deletedVal = findDeleted(selected, list);
			setSelected(list);
			let _deletedValObj = convertListItemToObject(deletedVal);
			let indexObj = prevList.findIndex(
				(val) => val.value === _deletedValObj.value
			);
			let _prevList = deleteFromArray(prevList, indexObj);
			setPrevList(_prevList);
			let index = prevSelected.indexOf(deletedVal);
			let _prevSelected = deleteFromArray(prevSelected, index);
			setPrevSelected(_prevSelected);
		}
	};

	const renderFilterUsers = () => {
		return (
			<div className="column">
				<SearchUserBox searchedUsers={(val) => setUsersOptions(val)} />
				<div className="popover-container">
					{prevSelected.length > 0 && (
						<div className="mt-2 mb-1" style={{ borderBottom: "1px solid" }}>
							<div className="d-flex justify-content-between">
								<span>Selected</span>
								<button
									type="link"
									className="link"
									onClick={() => {
										removeUserFilter();
									}}
								>
									Clear
								</button>
							</div>
							<RSuiteCheckboxGroup
								value={prevSelected}
								onChange={(list, event) => {
									if (event.target.checked) {
										setPrevSelected(list);
									} else {
										let deletedVal = findDeleted(prevSelected, list);
										setPrevSelected(list);
										let _deletedValObj = convertListItemToObject(deletedVal);
										let indexObj = prevList.findIndex(
											(val) => val.value === _deletedValObj.value
										);
										let _prevList = deleteFromArray(prevList, indexObj);
										setPrevList(_prevList);
										let index = selected.indexOf(deletedVal);
										let _selected = deleteFromArray(selected, index);
										setSelected(_selected);
									}
								}}
							>
								{prevList.map((user, index) => (
									<RSuiteCheckbox key={index} value={user?.value}>
										{user?.label}
									</RSuiteCheckbox>
								))}
							</RSuiteCheckboxGroup>
						</div>
					)}
					{usersOptions.length ? (
						<>
							<span>Select</span>
							<RSuiteCheckboxGroup value={selected} onChange={onChangeUser}>
								{usersOptions.map((user, index) => (
									<RSuiteCheckbox key={index} value={user?.value}>
										{user?.label}
									</RSuiteCheckbox>
								))}
							</RSuiteCheckboxGroup>
						</>
					) : null}
				</div>

				<div className="right">
					<button
						className="rs-btn rs-btn-medium mr-r5"
						onClick={() => handleCloseFilter()}
					>
						Close
					</button>
					<button
						className="rs-btn rs-btn-primary rs-btn-sm"
						onClick={() => handleSetUserFilter()}
					>
						Apply
					</button>
				</div>
			</div>
		);
	};

	const renderFilterDate = () => {
		return (
			<div>
				<DateRangePicker
					placement="autoHorizontalStart"
					value={
						filteredOptions?.[selectedColumn?.alias]
							? filteredOptions?.[selectedColumn?.alias]
							: null
					}
					placeholder="Select Date Range"
					onChange={handleSetFilterDate}
					onClean={handleSetFilterDate}
					format="MM-dd-yyyy"
				/>
			</div>
		);
	};

	const resetAllFilters = () => {
		let tempArr = [];
		for (let i = 0; i < columns?.length; i++) {
			if ("aliasFilter" in columns[i]) {
				tempArr[columns[i].aliasFilter] = false;
			}
		}
		setFilterArray(tempArr);
	};

	return (
		<thead>
			<tr>
				{columns.map((column, i) => {
					if (column.type === "checkbox")
						return (
							<th className={renderClass(column)} key={i}>
								{column.label}
							</th>
						);
					return (
						<th className={renderClass(column)} key={i}>
							<div className="flex-th">
								<span
									onClick={() => raiseSort(column)}
									className={`${column.label == "Action" ? "pad-span" : ""}`}
								>
									{column.label} {renderSortIcon(column)}{" "}
								</span>
								{column.filterDate && (
									<Popover
										placement="rightTop"
										className="cursor-pointer"
										content={renderFilterDate}
										trigger="click"
									>
										<FiFilter
											color={
												filteredOptions?.[column?.alias]?.length
													? "blue"
													: "grey"
											}
											onClick={() => {
												resetAllFilters();
												setSelectedColumn(column);
											}}
										/>
									</Popover>
								)}
								{column.filterUsers && (
									<Popover
										placement="rightTop"
										className="cursor-pointer"
										content={renderFilterUsers}
										// trigger="click"
										open={filterArray[column.aliasFilter]}
									>
										<FiFilter
											color={
												searchedUsers?.[columnKey]?.[column?.aliasFilter]
													?.length
													? "blue"
													: "grey"
											}
											onClick={() => {
												let obj = {};
												for (const property in filterArray) {
													if (property == column.aliasFilter) {
														obj[property] = filterArray[column.aliasFilter]
															? false
															: true;
													} else {
														obj[property] = false;
													}
												}
												setFilterArray(obj);
												setSelectedColumn(column);
											}}
										/>
									</Popover>
								)}
								{column.filterOptions && (
									<Popover
										placement="rightTop"
										className="cursor-pointer"
										content={renderFilterOptions}
										// trigger="click"
										open={filterArray[column.aliasFilter]}
									>
										<FiFilter
											color={
												filteredOptions?.[column?.aliasFilter]?.length
													? "blue"
													: "grey"
											}
											onClick={() => {
												setCheckedList([]);
												let obj = {};
												for (const property in filterArray) {
													if (property == column.aliasFilter) {
														obj[property] = filterArray[column.aliasFilter]
															? false
															: true;
													} else {
														obj[property] = false;
													}
												}
												setFilterArray(obj);
												setSelectedColumn(column);
												setPlainOptions(column.filterOptions);
												if (filteredOptions?.[column?.aliasFilter])
													setCheckedList(
														filteredOptions?.[column?.aliasFilter]
													);
											}}
										/>
									</Popover>
								)}
							</div>
						</th>
					);
				})}
			</tr>
		</thead>
	);
};

/******************************************************************************************
@Purpose    :   To validate the props
*******************************************************************************************/
PropTypes.propTypes = {
	columns: PropTypes.array.isRequired,
	headerDropdown: PropTypes.array.isRequired,
	columnKey: PropTypes.string.isRequired,
};

export default TableHeader;
